import $ from 'jquery';
import { FC, Fragment, useEffect, useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import Link from "../../common/Link";
import { NavbarItem } from "../Navbar";
import "./TabletNavbar.css";

const TabletNavbar: FC<{
    navLinkClickHandler: (linkId: string, elementId: string) => void,
    navbar: NavbarItem[]
}> = ({ navLinkClickHandler, navbar }) => {
    const [openSecondaryMenu, setOpenSecondaryMenu] = useState<boolean>(false);
    const [currentNavbarItem, setCurrentNavbarItem] = useState<NavbarItem | undefined>(undefined);
    const [show, setShow] = useState(false);

    function closeDropdowns() {
        var win = $(window);
        var width = win.width();
        if (typeof width !== 'undefined') {
            if (width >= 992 || width <= 768) {
                setOpenSecondaryMenu(false);
                setShow(false)
            }
        }
    }

    useEffect(() => {
        closeDropdowns()
        $(window).on('resize', function () {
            closeDropdowns()
        });
    }, []);

    const getSubRoutesContent = (item: NavbarItem, index: number, href?: string) => {
        return item.headerNavbar ? <Col key={index}>
            {
                !item.path || !href ? <span
                    className="disabled-route nav-link"
                    title={item.name}
                >
                    {item.name}
                </span> : <Link
                    className="title-route nav-link"
                    href={href}
                    title={item.name}
                >
                    {item.name}
                </Link>
            }
            {
                item.subRoutes && item.subRoutes.length ? (
                    <ul id={`navbar-${item.id}-dropdown-items`} className="">
                        {
                            item.subRoutes.map((item3: NavbarItem, index3: number) => {
                                let href3 = typeof item3.path !== 'undefined'
                                    ? (currentNavbarItem?.path ?? '') + (item.path ?? '') + item3.path
                                    : undefined;
                                return item3.headerNavbar ? <li key={index3}>
                                    {
                                        !item3.path || !href3 ? <span
                                            className="nav-link"
                                            title={item3.name}
                                        >
                                            {item3.name}
                                        </span> : <Link
                                            className="nav-link"
                                            href={href3}
                                            title={item3.name}
                                            onClick={() => setOpenSecondaryMenu(false)}
                                        >
                                            {item3.name}
                                        </Link>
                                    }
                                </li> : <Fragment key={index3}></Fragment>
                            })
                        }
                    </ul>
                ) : <Fragment />}
        </Col> : <Fragment key={index}></Fragment>
    }

    return <>
        <Dropdown
            id="tablet-dropdown-main"
            className="d-none d-md-flex align-items-md-center d-lg-none"
            show={show}
            onToggle={(isOpen) => {
                setShow(isOpen);
                navLinkClickHandler('navbar-search-link', 'navbar-search')
                if (!isOpen)
                    setOpenSecondaryMenu(false)
            }}
        >
            <Dropdown.Toggle
                id="tablet-dropdown"
                data-target="#tablet-dropdown-menu"
                className="float-end border-0 shadow-none"
            >
                <span className="navbar-toggler-icon"></span>
            </Dropdown.Toggle>
            <Dropdown.Menu id="tablet-dropdown-menu" className="tablet-dropdown-menu" align="start">
                {
                    navbar.filter(item => item.headerNavbar).map((item: NavbarItem, index: number) => {
                        return item.subRoutes?.length ? (
                            <Dropdown.Item
                                id={`navbar-${item.id}`}
                                key={index}
                                className="nav-item"
                                title={item.name}
                                as={Link}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setOpenSecondaryMenu(true)
                                    setCurrentNavbarItem(item)
                                }}
                            // onClick={() => navLinkClickHandler('navbar-search-link', 'navbar-search')}
                            >
                                {item.name}
                            </Dropdown.Item>
                        ) : (
                            <Dropdown.Item
                                key={index}
                                className="nav-item"
                                href={item.path ? item.path : undefined}
                                as={Link}
                            >
                                {item.name}
                            </Dropdown.Item>
                        )
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
        {
            openSecondaryMenu && <div className="tablet-secondary-menu position-absolute">
                <Row>
                    {
                        currentNavbarItem && currentNavbarItem.subRoutes && currentNavbarItem.subRoutes.map(
                            (item2: NavbarItem, index2: number) => {
                                let href2 = typeof item2.path !== 'undefined' ? (currentNavbarItem.path ?? '') + item2.path : undefined;
                                return getSubRoutesContent(item2, index2, href2)
                            }
                        )
                    }
                </Row>
            </div>
        }
    </>
}

export default TabletNavbar;